const appBarSteps = [
  {
    id: 'hamburger-menu',
    attachTo: {
      element: '[data-introid="hamburger-menu"]',
      on: 'bottom',
    },
    text: 'This is the hamburger menu, it opens the side drawer menu.',
    title: 'Hamburger Menu',
  },
  {
    id: 'page-title',
    attachTo: {
      element: '[data-introid="page-title"]',
      on: 'bottom',
    },
    text: 'You can navigate to the Dashboard by clicking the site title.',
    title: 'Site Title',
  },
  {
    id: 'notification-bell',
    attachTo: {
      element: '[data-introid="notification-bell"]',
      on: 'bottom',
    },
    text: 'Here you can check all of your notifications.',
    title: 'Notifications',
  },
  {
    id: 'profile-menu-toggle',
    attachTo: {
      element: '[data-introid="profile-menu-toggle"]',
      on: 'bottom',
    },
    text: "Shows the role(s) you have in the software and it's a drop-down menu.",
    title: 'Roles/Menu',
  },
];

export const welcomePageTour = {
  steps: [
    {
      element: '[data-introid="main-drawer"]',
      intro: 'This is main drawer used to access all of the tools and features.',
      title: 'Main Drawer',
      position: 'right',
    },
    ...appBarSteps,
    {
      element: '[data-introid="fab-button"]',
      intro: 'Click on this button to add new content',
      position: 'right',
    },
  ],
};

export const siteDirectorTour = {
  steps: [
    ...appBarSteps,
    // {
    //   id: 'main-drawer',
    //   attachTo: {
    //     element: '[data-introid="main-drawer"]',
    //     on: 'auto',
    //   },
    //   text: 'This is main drawer used to access all of the tools and features.',
    //   title: 'Main Drawer',
    // },
    {
      id: 'drawer-food-donors',
      attachTo: {
        element: '[data-introid="drawer-food-donors"]',
        on: 'left',
      },
      text: 'Browse, add, or modify food donors, including their Donations and Pickup Locations.',
      title: 'Food Donors',
    },
    {
      id: 'drawer-receivers',
      attachTo: {
        element: '[data-introid="drawer-receivers"]',
        on: 'left',
      },
      text: 'Browse, add, or modify Receiving Agencies.',
      title: 'Receiving Agencies',
    },
    {
      id: 'drawer-rescuers',
      attachTo: {
        element: '[data-introid="drawer-rescuers"]',
        on: 'left',
      },
      text: 'Browse, add, or modifiy Rescuers.',
      title: 'Rescuers',
    },
    {
      id: 'drawer-donations',
      attachTo: {
        element: '[data-introid="drawer-donations"]',
        on: 'left',
      },
      text: 'Browse, add, and modify Rescues.',
      title: 'Rescues',
      position: 'right',
    },
    {
      id: 'drawer-users',
      attachTo: {
        element: '[data-introid="drawer-users"]',
        on: 'left',
      },
      text:
        'Browse, add, or modify users for the current site (including rescuers, donor staff, and receiving agency staff). As well as send SMS and Email messages.',
      title: 'Site Users',
      position: 'right',
    },
    {
      id: 'map',
      attachTo: {
        element: '[data-introid="map"]',
        on: 'left',
      },
      text:
        "View the locations of Donors, Recievieing Agencies, and Rescuers, including a site's area in a map format.",
      title: 'Map',
      position: 'right',
    },
    {
      id: 'rescue-gallery',
      attachTo: {
        element: '[data-introid="rescue-gallery"]',
        on: 'left',
      },
      text: 'View rescue photos uploaded by Rescuers.',
      title: 'Rescue Image Gallery',
      position: 'right',
    },
    {
      id: 'drawer-reports',
      attachTo: {
        element: '[data-introid="drawer-reports"]',
        on: 'left',
      },
      text: 'Browse specific data reports.',
      title: 'Reports',
      position: 'right',
    },
    {
      id: 'drawer-unassigned-useres',
      attachTo: {
        element: '[data-introid="drawer-unassigned-useres"]',
        on: 'left',
      },
      text: 'Browse users without any role in any site.',
      title: 'Unassigned Users',
      position: 'right',
    },
    {
      id: 'drawer-in-process-registrations',
      attachTo: {
        element: '[data-introid="drawer-in-process-registrations"]',
        on: 'left',
      },
      text: 'Browse users who are in the process of fully registering.',
      title: 'In-process Registrations',
      position: 'right',
    },
    {
      id: 'drawer-donor-organizations',
      attachTo: {
        element: '[data-introid="drawer-donor-organizations"]',
        on: 'left',
      },
      text: 'Browse, add or modify Food Donor parent companies/organizations.',
      title: 'Donor Organizations',
      position: 'right',
    },
    {
      id: 'drawer-sites-menu',
      attachTo: {
        element: '[data-introid="drawer-sites-menu"]',
        on: 'left',
      },
      text: 'Browse, add, or modify Sites. Change the current Site.',
      title: 'Sites Menu',
      position: 'right',
    },
    {
      id: 'drawer-sent-emails',
      attachTo: {
        element: '[data-introid="drawer-sent-emails"]',
        on: 'left',
      },
      text: 'Browse emails that site coordinators or site directors have sent to users.',
      title: 'Sent Emails',
      position: 'right',
    },
    {
      id: 'drawer-events',
      attachTo: {
        element: '[data-introid="drawer-events"]',
        on: 'left',
      },
      text: 'Create, view, and manage Events.',
      title: 'Events',
      position: 'right',
    },
    {
      id: 'fab-button',
      attachTo: {
        element: '[data-introid="fab-button"]',
        on: 'left',
      },
      text: 'Click on this button to add new content.',
      position: 'right',
    },
  ],
};

export const scheduleTour = [
  {
    element: '[data-introid="schedule-rescues-container"]',
    intro: 'By default, we are showing all rescues. You can change it by clicking the "Filters" button.',
    title: 'Rescues List',
  },
  {
    element: '[data-introid="schedule-filters"]',
    intro: 'Allows you to define custom filters for the rescues list.',
    title: 'Filters Button',
  },
];

export const infiniteScheduleTour = [
  {
    element: '[data-introid="schedule-rescues-container"]',
    intro: 'By default, we are showing all rescues. You can change it by clicking the "Filters" button.',
    title: 'Rescues List',
  },
  {
    element: '[data-introid="schedule-filters"]',
    intro: 'The filters button has changed location, click here if you wish to add any filters.',
    title: 'Filters Button',
  },
];

export const closeRescueTour = {
  steps: [
    {
      id: 'no-food',
      attachTo: {
        element: '[data-introid="no-food"]',
        on: 'top',
      },
      text: 'This is how you let your site director know that there was no food available to be rescued.',
      title: 'No food available',
    },
    {
      id: 'categories',
      attachTo: {
        element: '[data-introid="categories"]',
        on: 'top',
      },
      text: 'Select any category that applies to the contents of your rescue.',
      title: 'Categories',
    },
    {
      id: 'close-rescue-next',
      attachTo: {
        element: '[data-introid="close-rescue-next"]',
        on: 'top',
      },
      text: 'Select ‘Next’ to continue to the next step',
      title: 'Next',
      rescueCloseStep: 0,
      nextStep: true,
    },
    {
      id: 'true-weight',
      attachTo: {
        element: '[data-introid="true-weight"]',
        on: 'top',
      },
      text: 'Select whether you estimate rescue weight or it is weighted value',
      title: 'True Weight',
      rescueCloseStep: 1,
      prevStep: true,
    },
    {
      id: 'close-rescue-next',
      attachTo: {
        element: '[data-introid="close-rescue-next"]',
        on: 'top',
      },
      text: 'Select ‘Next’ to continue to the next step',
      title: 'Next',
      rescueCloseStep: 1,
      nextStep: true,
    },
    {
      id: 'weight-lbs',
      attachTo: {
        element: '[data-introid="weight-lbs"]',
        on: 'bottom',
      },
      text: 'Editing this field will adjust the total weight for your rescue.',
      title: 'Total weight',
      rescueCloseStep: 2,
      prevStep: true,
    },
    {
      id: 'item-lbs',
      attachTo: {
        element: '[data-introid="item-lbs"]',
        on: 'bottom',
      },
      text: 'Editing these fields will affect the total weight of your rescue, in addition to the distribution of weight amongst the categories.',
      title: 'Item weight',
    },
    {
      id: 'upload-photo',
      attachTo: {
        element: '[data-introid="upload-photo"]',
        on: 'top',
      },
      text: 'Use this button to upload a picture of your rescue. This step is optional but encouraged.',
      title: 'Photo',
    },
    {
      id: 'rescue-comments',
      attachTo: {
        element: '[data-introid="rescue-comments"]',
        on: 'top',
      },
      text: 'This comment section is where you can provide any information you think would be helpful to your site director!',
      title: 'Comments',
    },
  ],
};

export const closeRescueTourDonorLink = {
  steps: [
    {
      id: 'no-food',
      attachTo: {
        element: '[data-introid="no-food"]',
        on: 'top',
      },
      text: 'This is how you let your site director know that there was no food available to be rescued.',
      title: 'No food available',
    },
    {
      id: 'donor-receipt',
      attachTo: {
        element: '[data-introid="donor-receipt"]',
        on: 'top',
      },
      text: 'This receipt displays any items logged to this rescue by the food donor.',
      title: 'Donor Receipt',
      nextStep: true,
      rescueCloseStep: 0,
    },
    {
      id: 'categories',
      attachTo: {
        element: '[data-introid="categories"]',
        on: 'top',
      },
      text: 'Select any category that applies to the contents of your rescue.',
      title: 'Categories',
      rescueCloseStep: 1,
      prevStep: true,
    },
    {
      id: 'close-rescue-next',
      attachTo: {
        element: '[data-introid="close-rescue-next"]',
        on: 'top',
      },
      text: 'Select ‘Next’ to continue to the next step',
      title: 'Next',
      rescueCloseStep: 1,
      nextStep: true,
    },
    {
      id: 'true-weight',
      attachTo: {
        element: '[data-introid="true-weight"]',
        on: 'top',
      },
      text: 'Select whether you estimate rescue weight or it is weighted value',
      title: 'True Weight',
      rescueCloseStep: 2,
      prevStep: true,
    },
    {
      id: 'close-rescue-next',
      attachTo: {
        element: '[data-introid="close-rescue-next"]',
        on: 'top',
      },
      text: 'Select ‘Next’ to continue to the next step',
      title: 'Next',
      rescueCloseStep: 2,
      nextStep: true,
    },
    {
      id: 'weight-lbs',
      attachTo: {
        element: '[data-introid="weight-lbs"]',
        on: 'bottom',
      },
      text: 'Editing this field will adjust the total weight for your rescue.',
      title: 'Total weight',
      rescueCloseStep: 3,
      prevStep: true,
    },
    {
      id: 'item-lbs',
      attachTo: {
        element: '[data-introid="item-lbs"]',
        on: 'bottom',
      },
      text: 'Editing these fields will affect the total weight of your rescue, in addition to the distribution of weight amongst the categories.',
      title: 'Item weight',
    },
    {
      id: 'upload-photo',
      attachTo: {
        element: '[data-introid="upload-photo"]',
        on: 'top',
      },
      text: 'Use this button to upload a picture of your rescue. This step is optional but encouraged.',
      title: 'Photo',
    },
    {
      id: 'rescue-comments',
      attachTo: {
        element: '[data-introid="rescue-comments"]',
        on: 'top',
      },
      text: 'This comment section is where you can provide any information you think would be helpful to your site director!',
      title: 'Comments',
    },
  ],
};

const mobileAppbar = [
  {
    id: 'user-toolbar',
    attachTo: {
      element: '[data-introid="user-toolbar"]',
      on: 'bottom',
    },
    text: 'The tools in this section will allow you to view notifications, access tours, and manage your profile.',
    title: 'Toolbar',
  },
];

const receiverMobileDashboard = [
  {
    id: 'receiver-next-rescue',
    attachTo: {
      element: '[data-introid="receiver-next-rescue"]',
      on: 'bottom',
    },
    text: 'This section will display your next rescue, in addition to helpful details like the rescuer, donor, and pickup window.',
    title: 'Next Rescue',
  },
  {
    id: 'receiver-schedule',
    attachTo: {
      element: '[data-introid="receiver-schedule"]',
      on: 'bottom',
    },
    text: 'This tile will show you any rescues currently scheduled and when to expect them.',
    title: 'Schedule',
  },
  {
    id: 'receiver-add-staff',
    attachTo: {
      element: '[data-introid="receiver-add-staff"]',
      on: 'bottom',
    },
    text: 'This tile will allow you to add staff members who are helping your agency manage rescues.',
    title: 'Add Staff',
  },
  {
    id: 'receiving-hours',
    attachTo: {
      element: '[data-introid="receiving-hours"]',
      on: 'top',
    },
    text: 'If you want to update the hours during which you can receive food rescues, this is the tile for you!',
    title: 'Edit Hours',
  },
  {
    id: 'receiver-food-preferences',
    attachTo: {
      element: '[data-introid="receiver-food-preferences"]',
      on: 'top',
    },
    text: 'We want to make sure we are delivering the food that your agency, use this tile to let us know which types of food your prefer!',
    title: 'Preferences',
  },
  {
    id: 'receiver-capacity',
    attachTo: {
      element: '[data-introid="receiver-capacity"]',
      on: 'top',
    },
    text: 'Use this tile to provide capacity information, so our site directors can make good routing decisions for you!',
    title: 'Capacity',
  },
];

const rescuerMobileDashboard = [
  {
    id: 'next-rescue',
    attachTo: {
      element: '[data-introid="next-rescue"]',
      on: 'bottom',
    },
    text: 'This section will tell you everything you need to know about your next rescue.',
    title: 'Next Rescue',
  },
  {
    id: 'my-impact',
    attachTo: {
      element: '[data-introid="my-impact"]',
      on: 'bottom',
    },
    text: 'This is where you can see the impact your work has had on the environment, and in your community. Thank you for being the rescue!',
    title: 'My Impact',
  },
  {
    id: 'claim-rescue',
    attachTo: {
      element: '[data-introid="claim-rescue"]',
      on: 'top',
    },
    text: 'Use this tile to find a new rescue, and add it to your schedule.',
    title: 'Claim A Rescue',
  },
  {
    id: 'my-rescues',
    attachTo: {
      element: '[data-introid="my-rescues"]',
      on: 'top',
    },
    text: 'This is where you go to close your rescues and view your schedule.',
    title: 'My Rescues',
  },
  {
    id: 'events',
    attachTo: {
      element: '[data-introid="events"]',
      on: 'top',
    },
    text: 'This is where you can view any upcoming events happening in your site, claim an event shift, or view your event schedule.',
    title: 'Events',
  },
  {
    id: 'id-mode',
    attachTo: {
      element: '[data-introid="id-mode"]',
      on: 'top',
    },
    text: 'Click on this tile if you need to identify yourself when picking up or dropping off a rescue.',
    title: 'ID Mode',
  },
  {
    id: 'badges',
    attachTo: {
      element: '[data-introid="badges"]',
      on: 'top',
    },
    text: "This is where you can view any badges you've been awarded for your rescue achievements and view your progress towards earning a new badge.",
    title: 'Badges',
  },
  {
    id: 'site-goals',
    attachTo: {
      element: '[data-introid="site-goals"]',
      on: 'top',
    },
    text: 'This is where you can see how your food recovery site is progressing towards its goals.',
    title: 'Site Goals',
  },
];

export const tourOfTours = [
  {
    element: '[data-introid="tours"]',
    intro:
      "Need some help? Click this question mark to learn about the actions you can take on the page you're currently viewing.",
    title: 'Tours',
  },
];

export const RescuerMobileSchedule = {
  steps: [
    ...mobileAppbar,
    {
      id: 'claim-rescue-buttons',
      attachTo: {
        element: '[data-introid="claim-rescue-buttons"]',
        on: 'top',
      },
      text: `Select "I'll do it" to claim this rescue, or select "Adopt" to adopt the series of rescues.`,
      title: 'Claim Rescue',
    },
    {
      id: 'rescue-info',
      attachTo: {
        element: '[data-introid="rescue-info"]',
        on: 'top',
      },
      text: 'Click here to view contact information, notes, and route information for this rescue.',
      title: 'Info',
    },
    {
      id: 'schedule-filters',
      attachTo: {
        element: '[data-introid="schedule-filters"]',
        on: 'top',
      },
      text: 'Use the Filters button to find the right rescue for you and your schedule.',
      title: 'Filters',
    },
    {
      id: 'my-frus',
      attachTo: {
        element: '[data-introid="rescuerDesktopTab0"]',
        on: 'top',
      },
      text: 'This tab will display your recent rescues and allow you to close completed rescues.',
      title: 'My Dashboard',
    },
    {
      id: 'my-rescues',
      attachTo: {
        element: '[data-introid="rescuerDesktopTab1"]',
        on: 'top',
      },
      text: 'This tab will display your claimed or adopted rescues, and allow you to release a rescue.',
      title: 'My Rescues',
    },
  ],
};

const siteDirectorMobileDashboard = [
  {
    id: 'site',
    attachTo: {
      element: '[data-introid="site"]',
      on: 'bottom',
    },
    text: 'This is where you go to view the rescue schedule for your site.',
    title: 'Site',
  },
  {
    id: 'to-do',
    attachTo: {
      element: '[data-introid="to-do"]',
      on: 'bottom',
    },
    text: `Check here for alerts about tasks needing action—like unclaimed rescues, 
    donor requests, or other scenarios requiring a quick response.`,
    title: 'To-do',
  },
  {
    id: 'quick-add',
    attachTo: {
      element: '[data-introid="quick-add"]',
      on: 'bottom',
    },
    text: 'Use this button to add a new donor, agency, or rescue.',
    title: 'Quick Add',
  },
];

export const ReceiverMobileSchedule = {
  steps: [
    ...mobileAppbar,
    {
      id: 'upcoming-rescue',
      attachTo: {
        element: '[data-introid="upcoming-rescue"]',
        on: 'top',
      },
      text: 'This section will display details about future rescues, with helpful context like the assigned rescuer, donor, and pickup window.',
      title: 'Rescue Details',
    },
    {
      id: 'recent-rescue',
      attachTo: {
        element: '[data-introid="recent-rescue"]',
        on: 'top',
      },
      text: 'This section will display details about previous rescues, with helpful context like the assigned rescuer, donor, and pickup window.',
      title: 'Rescue Details',
    },
    {
      id: 'receiver-dashboard-mobile-schedule',
      attachTo: {
        element: '[data-introid="receiver-dashboard-mobile-schedule"]',
        on: 'top',
      },
      text: 'Use this tool bar to toggle between future rescues and past rescues.',
      title: 'Navigation',
    },
  ],
};

export const mobileDashboard = {
  steps: [
    ...mobileAppbar,
    ...rescuerMobileDashboard,
    ...siteDirectorMobileDashboard,
    ...receiverMobileDashboard,
  ],
};

export const nativeRescuerWelcomeTour = (siteDirector) => ({
  steps: [
    {
      id: 'tours',
      attachTo: {
        element: '[data-introid="tours"]',
        on: 'bottom',
      },
      text: "Need some help? Click this question mark to learn about the actions you can take on the page you're currently viewing.",
      title: 'Tours',
    },
    {
      id: 'user-manual',
      beforeShowPromise: () =>
        new Promise((resolve) => {
          document.querySelector('[data-introid="profile-menu-toggle"]').click();
          setTimeout(resolve, 300); // open profile menu
        }),
      attachTo: {
        element: '[data-introid="user-manual"]',
        on: 'bottom',
      },
      text: "The User Manual has searchable articles for features, pages and concepts, and is a good place to start if you have questions!",
      title: 'User Manual',
    },
    {
      id: 'ask-sd',
      beforeShowPromise: () => document.querySelector('.MuiBackdrop-root').click(),
      attachTo: {
        element: '#ask-sd',
      },
      text: `If you still need help, you can always email your site director, <b>${siteDirector.firstname} ${siteDirector.lastname}</b>, at <a href="mailto:${siteDirector.email}">${siteDirector.email}</a>, and they will be more than happy to answer questions!`,
      title: 'Ask your Site Director',
    },
    {
      id: 'learn',
      attachTo: {
        element: '[data-introid="learn"]',
        on: 'top',
      },
      text: "Explore food recovery best practices, watch short videos, take quizzes, and earn badges. Start with these course to get ready for your first rescue!",
      title: 'Learn Center',
      startLearning: true,
    },
  ],
});
